import React, { FC, useState } from 'react';
import { CircularProgress, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import some from 'lodash/some';
import { IUserNotification } from 'interfaces/userNotification.interfaces';
import UserNotificationsSubheader from './UserNotificationsSubheader';
import UserNotificationsHeader from './UserNotificationsHeader';
import UserNotificationsMenu from './UserNotificationsMenu';

const useStyles = makeStyles(() => ({
  popover: {
    '& .MuiPopover-paper': {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      overflowY: 'hidden',
      left: 'unset !important',
      top: '78px !important',
      right: '8px !important',
      bottom: '8px !important',
      width: '440px',
      padding: '20px 0',
    },
  },
  headerContainer: {
    padding: '0 24px',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
}));

interface IUserNotificationsPopover {
  menuAnchorEl: HTMLElement | null;
  userNotifications: IUserNotification[];
  onClose: () => void;
  loading: boolean;
}

const UserNotificationsPopover: FC<IUserNotificationsPopover> = ({
  menuAnchorEl,
  userNotifications,
  onClose,
  loading,
}) => {
  const [groupStatus, setGroupStatus] = useState<'all' | 'unread'>('unread');
  const classes = useStyles();
  let uNotifications: IUserNotification[];

  if (groupStatus === 'unread') {
    uNotifications = userNotifications.filter(item => !item.read);
  } else {
    uNotifications = userNotifications;
  }

  const hasUnreadNotification = some(uNotifications, item => !item.read);

  return (
    <Popover className={classes.popover} anchorEl={menuAnchorEl} onClose={onClose} open>
      <div className={classes.headerContainer}>
        <UserNotificationsHeader onClose={onClose} />

        <UserNotificationsSubheader
          groupStatus={groupStatus}
          setGroupStatus={setGroupStatus}
          hasUnreadNotification={hasUnreadNotification}
          userNotificationsLoading={loading}
        />
      </div>

      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        <UserNotificationsMenu userNotifications={uNotifications} groupStatus={groupStatus} />
      )}
    </Popover>
  );
};

export default UserNotificationsPopover;
